module.exports = __webpack_public_path__ + "static/img/meimengchengzhen.458fa30.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/meimengchengzhen.png
// module id = IIfY
// module chunks = 1